export const SortAscSVG = (
  <span className="self-start">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-4 h-4"
    >
      <path
        fillRule="evenodd"
        d="M14.77 12.79a.75.75 0 01-1.06-.02L10 8.832 6.29 12.77a.75.75 0 11-1.08-1.04l4.25-4.5a.75.75 0 011.08 0l4.25 4.5a.75.75 0 01-.02 1.06z"
        clipRule="evenodd"
      />
    </svg>
  </span>
);

export const SortDescSVG = (
  <span className="self-end">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-4 h-4"
    >
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  </span>
);

export const SortNoneSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    className="w-4 h-4"
  >
    <path
      fillRule="evenodd"
      d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
      clipRule="evenodd"
    />
  </svg>
);

export const TestConnectionStatusIdleSVG = (
  <svg
    className="mx-auto h-32 w-32"
    viewBox="0 0 221 221"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M189.822 31.6981C186.928 14.0185 145.591 0 95 0C44.4085 0 3.07167 14.0185 0.178125 31.6981H0V33.6792V79.2453V81.2264V83.2075V126.792V128.774V130.755V178.302H0.178125C3.07167 195.978 44.4125 210 95 210C145.587 210 186.928 195.978 189.822 178.302H190V130.755V128.774V126.792V83.2075V81.2264V79.2453V33.6792V31.6981H189.822Z"
      fill="url(#paint0_linear_3843_925)"
    />
    <path
      d="M95 67.3585C147.467 67.3585 190 52.2798 190 33.6792C190 15.0787 147.467 0 95 0C42.5329 0 0 15.0787 0 33.6792C0 52.2798 42.5329 67.3585 95 67.3585Z"
      fill="#FEB272"
    />
    <path
      d="M97 114.5C29 113.7 4 93.1667 0 83V77C20.8 106.6 68.5 110 97 110C156.2 111.2 179.682 96 190 77V83C179.6 108.2 132.5 114.5 97 114.5Z"
      fill="white"
    />
    <path
      d="M97 165.5C29 164.7 4 144.167 0 134V128C20.8 157.6 68.5 161 97 161C156.2 162.2 179.682 147 190 128V134C179.6 159.2 132.5 165.5 97 165.5Z"
      fill="white"
    />
    <path
      d="M176 218C200.853 218 221 197.853 221 173C221 148.147 200.853 128 176 128C151.147 128 131 148.147 131 173C131 197.853 151.147 218 176 218Z"
      fill="#FEB272"
    />
    <path
      d="M204 176H179V151C179 148.24 176.765 146 174 146C171.235 146 169 148.24 169 151V181C169 183.76 171.235 186 174 186H204C206.765 186 209 183.76 209 181C209 178.24 206.765 176 204 176Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3843_925"
        x1="95"
        y1="0"
        x2="95"
        y2="210"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.345269" stopColor="#FDBE90" />
        <stop offset="0.903283" stopColor="#C2621A" />
      </linearGradient>
    </defs>
  </svg>
);

export const HomeMenuSVG = (
  <span className="text-blue-600">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 25"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
      />
    </svg>
  </span>
);

export const DataValidationMenuSVG = (
  <span className="text-orange-500">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 25"
      strokeWidth={1.5}
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
      />
    </svg>
  </span>
);

export const DataConnectorMenuSVG = (
  <span className="text-cyan-500">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125"
      ></path>
    </svg>
  </span>
);

export const MetadataMonitoringMenuSVG = (
  <span className="text-indigo-500">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.25 9.75L16.5 12l-2.25 2.25m-4.5 0L7.5 12l2.25-2.25M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
      />
    </svg>
  </span>
);

export const DWDocumentationMenuSVG = (
  <span className="text-red-500">
    {" "}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      {" "}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
      />{" "}
    </svg>{" "}
  </span>
);

export const CloudMonitorMenuSVG = (
  <span className="text-blue-500">
    {" "}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      {" "}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5m.75-9l3-3 2.148 2.148A12.061 12.061 0 0116.5 7.605"
      />{" "}
    </svg>{" "}
  </span>
);

export const OptimizerForkLiftSVG = (
  <span className="text-amber-500">
    <svg
      className="w-6 h-6"
      viewBox="0 -1 24 24"
      id="meteor-icon-kit__regular-forklift"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.58579 10H2V15.3368C2.45463 15.1208 2.9632 15 3.5 15C4.8962 15 6.10145 15.8175 6.66318 17H10.3368C10.8985 15.8175 12.1038 15 13.5 15C14.0368 15 14.5454 15.1208 15 15.3368V13H9C8.73478 13 8.48043 12.8946 8.29289 12.7071L5.58579 10zM3 8V1C3 0.44772 3.44772 0 4 0H11C11.3921 0 11.7481 0.2292 11.9104 0.5862L16.6439 11H19V3C19 2.44772 19.4477 2 20 2C20.5523 2 21 2.44772 21 3V19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H20C19.4477 21 19 20.5523 19 20V19H16.9646C16.7219 20.6961 15.2632 22 13.5 22C11.7368 22 10.2781 20.6961 10.0354 19H6.96456C6.72194 20.6961 5.26324 22 3.5 22C1.567 22 0 20.433 0 18.5C0 18.3899 0.00507963 18.2811 0.0150172 18.1736C0.00514672 18.1172 0 18.0592 0 18V9C0 8.44771 0.447715 8 1 8H3zM14.447 11L10.3561 2H5V8H6C6.26522 8 6.51957 8.10536 6.70711 8.29289L9.41421 11H14.447zM17 13V17H19V13H17zM3.5 20C4.32843 20 5 19.3284 5 18.5C5 17.6716 4.32843 17 3.5 17C2.67157 17 2 17.6716 2 18.5C2 19.3284 2.67157 20 3.5 20zM13.5 20C14.3284 20 15 19.3284 15 18.5C15 17.6716 14.3284 17 13.5 17C12.6716 17 12 17.6716 12 18.5C12 19.3284 12.6716 20 13.5 20z"
        fill="#FFD000"
      />
    </svg>
  </span>
);

export const OptimizerRecoverySVG = (
  <span className="">
    <svg
      x="0px"
      y="0px"
      className="w-6 h-6"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
    >
      <image
        id="image0"
        width="512"
        height="512"
        x="0"
        y="0"
        href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABGdBTUEAALGPC/xhBQAAACBjSFJN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"
      />
    </svg>
  </span>
);

export const OptimizerGearSVG = (
  <span className="text-emerald-500">
    <svg
      className="w-6 h-6"
      viewBox="0 -1 24 24"
      id="meteor-icon-kit__regular-forklift"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.58579 10H2V15.3368C2.45463 15.1208 2.9632 15 3.5 15C4.8962 15 6.10145 15.8175 6.66318 17H10.3368C10.8985 15.8175 12.1038 15 13.5 15C14.0368 15 14.5454 15.1208 15 15.3368V13H9C8.73478 13 8.48043 12.8946 8.29289 12.7071L5.58579 10zM3 8V1C3 0.44772 3.44772 0 4 0H11C11.3921 0 11.7481 0.2292 11.9104 0.5862L16.6439 11H19V3C19 2.44772 19.4477 2 20 2C20.5523 2 21 2.44772 21 3V19H23C23.5523 19 24 19.4477 24 20C24 20.5523 23.5523 21 23 21H20C19.4477 21 19 20.5523 19 20V19H16.9646C16.7219 20.6961 15.2632 22 13.5 22C11.7368 22 10.2781 20.6961 10.0354 19H6.96456C6.72194 20.6961 5.26324 22 3.5 22C1.567 22 0 20.433 0 18.5C0 18.3899 0.00507963 18.2811 0.0150172 18.1736C0.00514672 18.1172 0 18.0592 0 18V9C0 8.44771 0.447715 8 1 8H3zM14.447 11L10.3561 2H5V8H6C6.26522 8 6.51957 8.10536 6.70711 8.29289L9.41421 11H14.447zM17 13V17H19V13H17zM3.5 20C4.32843 20 5 19.3284 5 18.5C5 17.6716 4.32843 17 3.5 17C2.67157 17 2 17.6716 2 18.5C2 19.3284 2.67157 20 3.5 20zM13.5 20C14.3284 20 15 19.3284 15 18.5C15 17.6716 14.3284 17 13.5 17C12.6716 17 12 17.6716 12 18.5C12 19.3284 12.6716 20 13.5 20z"
        fill="#758CA3"
      />
    </svg>
  </span>
);
export const AdministrationMenuSVG = (
  <svg
    className="w-5 h-5 text-red-500"
    strokeWidth="8"
    fill="none"
    stroke="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 92.88 96.17"
  >
    <path d="M0,107.68c0-32.08,26.21-21,35-32.2,6.45,15.23,29.74,13.94,37.63,0A11.7,11.7,0,0,0,76,78a8.26,8.26,0,0,0,.4,5.29l.27.55a11.12,11.12,0,0,0-1.24.39,8.54,8.54,0,0,0-4.55,4.55l-.2.58a8.37,8.37,0,0,0-.41,2.57v5.27a8.25,8.25,0,0,0,.63,3.16l.25.51A8.42,8.42,0,0,0,72.6,103l.14.14a8.18,8.18,0,0,0,2.59,1.75l.66.24a8.47,8.47,0,0,0-1.06,2.56ZM115.64,79.32a2,2,0,0,0-2.9,0l-2.22,2.21a15.3,15.3,0,0,0-1.87-1,19,19,0,0,0-2-.78V76.34a2,2,0,0,0-.59-1.46,2,2,0,0,0-1.45-.59h-4.26a2,2,0,0,0-1.43.59,2,2,0,0,0-.61,1.46v3.1a15.41,15.41,0,0,0-2.06.64,15.89,15.89,0,0,0-1.91.88l-2.45-2.42a1.88,1.88,0,0,0-1.42-.61,2,2,0,0,0-1.45.61l-3,3a2,2,0,0,0,0,2.9l2.21,2.22a14.06,14.06,0,0,0-1,1.87,19,19,0,0,0-.78,2H83a2,2,0,0,0-2,2v4.26a2,2,0,0,0,.59,1.43,1.94,1.94,0,0,0,1.45.61h3.11a15.41,15.41,0,0,0,.64,2.06,19,19,0,0,0,.87,1.95l-2.41,2.41a1.85,1.85,0,0,0-.61,1.42,2,2,0,0,0,.61,1.45l3,3a2.13,2.13,0,0,0,2.9,0l2.21-2.25a14.18,14.18,0,0,0,1.88,1,19.67,19.67,0,0,0,2,.78v3.4a2,2,0,0,0,2,2h4.26a2,2,0,0,0,2-2V111a17,17,0,0,0,2.06-.63c.67-.26,1.32-.56,2-.88l2.41,2.41a1.86,1.86,0,0,0,1.43.62,1.9,1.9,0,0,0,1.44-.62l3-3a2.13,2.13,0,0,0,0-2.9l-2.25-2.21a14.18,14.18,0,0,0,1-1.88,19.67,19.67,0,0,0,.78-2h3.39a2,2,0,0,0,1.46-.6,2,2,0,0,0,.59-1.45V93.63a2,2,0,0,0-.59-1.43,2,2,0,0,0-1.46-.6h-3.1a17.31,17.31,0,0,0-.64-2,15.49,15.49,0,0,0-.88-1.93l2.42-2.45a1.88,1.88,0,0,0,.61-1.41,2.05,2.05,0,0,0-.61-1.46l-3-3Zm-13.7,7.57a8.27,8.27,0,0,1,3.25.65A8.23,8.23,0,0,1,109.63,92a8.45,8.45,0,0,1,0,6.5,8.23,8.23,0,0,1-4.44,4.44,8.45,8.45,0,0,1-6.5,0,8.23,8.23,0,0,1-4.44-4.44,8.45,8.45,0,0,1,0-6.5,8.23,8.23,0,0,1,4.44-4.44,8.27,8.27,0,0,1,3.25-.65ZM30.74,42a5,5,0,0,0-2.67.7,2,2,0,0,0-.77.88A3.11,3.11,0,0,0,27.05,45c.05,1.62.89,3.73,2.53,6.17l0,0h0l5.31,8.45C37,63.05,39.28,66.5,42.06,69a14.58,14.58,0,0,0,10.19,4.1A15,15,0,0,0,63,68.86c2.86-2.68,5.13-6.36,7.35-10l6-9.86c1.12-2.55,1.53-4.26,1.27-5.25-.15-.6-.81-.89-1.93-.95-.24,0-.48,0-.73,0l-.84.05a1.75,1.75,0,0,1-.46,0A9.15,9.15,0,0,1,72,42.7l2.06-9.08c-15.22,2.4-26.6-8.9-42.68-2.26l1.16,10.7A9.16,9.16,0,0,1,30.74,42Zm47-1.92A3.89,3.89,0,0,1,80.56,43c.43,1.67,0,4-1.46,7.26h0l-.09.17L73,60.4c-2.33,3.84-4.7,7.7-7.86,10.66a17.86,17.86,0,0,1-12.83,5.09A17.46,17.46,0,0,1,40,71.26c-3.07-2.82-5.42-6.45-7.66-10l-5.32-8.45c-1.94-2.9-3-5.55-3-7.72a6.2,6.2,0,0,1,.52-2.77,5.22,5.22,0,0,1,1.82-2.12,6,6,0,0,1,1.29-.65,136.66,136.66,0,0,1-.25-15.2,21.8,21.8,0,0,1,.65-3.43,20.41,20.41,0,0,1,9-11.45,28.41,28.41,0,0,1,7.53-3.35c1.68-.48-1.44-5.88.31-6C53.33-.8,67,6.9,72.88,13.28c2.94,3.2,4.8,7.42,5.2,13l-.33,13.78Z" />
  </svg>
);

export const InitialSetupMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6"
  >
    <path d="M18.75 12.75h1.5a.75.75 0 000-1.5h-1.5a.75.75 0 000 1.5zM12 6a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 6zM12 18a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 0112 18zM3.75 6.75h1.5a.75.75 0 100-1.5h-1.5a.75.75 0 000 1.5zM5.25 18.75h-1.5a.75.75 0 010-1.5h1.5a.75.75 0 010 1.5zM3 12a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5A.75.75 0 013 12zM9 3.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM12.75 12a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM9 15.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5z" />
  </svg>
);

export const AccessManagementMenuSVG = (
  <span className="text-fuchsia-500">
    {" "}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      {" "}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
      />{" "}
    </svg>{" "}
  </span>
);

export const SystemLogsMenuSVG = (
  <span className="text-gray-500">
    {" "}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
      className="w-6 h-6"
    >
      {" "}
      <path
        fillRule="evenodd"
        d="M2 4.25A2.25 2.25 0 014.25 2h11.5A2.25 2.25 0 0118 4.25v8.5A2.25 2.25 0 0115.75 15h-3.105a3.501 3.501 0 001.1 1.677A.75.75 0 0113.26 18H6.74a.75.75 0 01-.484-1.323A3.501 3.501 0 007.355 15H4.25A2.25 2.25 0 012 12.75v-8.5zm1.5 0a.75.75 0 01.75-.75h11.5a.75.75 0 01.75.75v7.5a.75.75 0 01-.75.75H4.25a.75.75 0 01-.75-.75v-7.5z"
        clipRule="evenodd"
      />{" "}
    </svg>{" "}
  </span>
);

// export const SystemLogsMenuSVG = <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.5 122.9" className="w-6 h-5 text-stone-600" fill="currentColor" stroke="currentColor" strokeWidth="1.5" ><path className="st0" d="M105.4,76.3l3.8,3.8c1,1,1,2.6,0,3.6l-3.1,3.1c0.8,1.6,1.5,3.3,1.9,5.1h4c1.4,0,2.6,1.2,2.6,2.6v5.4 c0,1.4-1.2,2.6-2.6,2.6h-4.3c-0.5,1.7-1.3,3.4-2.2,4.9l2.8,2.8c1,1,1,2.6,0,3.6l-3.8,3.8c-1,1-2.6,1-3.6,0l-3.1-3.1 c-1.6,0.8-3.3,1.5-5.1,1.9v4c0,1.4-1.2,2.6-2.6,2.6h-5.4c-1.4,0-2.6-1.2-2.6-2.6V116c-1.7-0.5-3.4-1.3-4.9-2.2l-2.8,2.8 c-1,1-2.6,1-3.6,0l-3.8-3.8c-1-1-1-2.6,0-3.6l3.1-3.1c-0.8-1.6-1.5-3.3-1.9-5.1h-4c-1.4,0-2.6-1.2-2.6-2.6v-5.4 c0-1.4,1.2-2.6,2.6-2.6h4.3c0.5-1.7,1.3-3.4,2.2-4.9L68,82.8c-1-1-1-2.6,0-3.6l3.8-3.8c1-1,2.6-1,3.6,0l3.1,3.1 c1.6-0.8,3.3-1.5,5.1-1.9v-4c0-1.4,1.2-2.6,2.6-2.6h5.4c1.4,0,2.6,1.2,2.6,2.6v4.3c1.7,0.5,3.4,1.3,4.9,2.2l2.8-2.8 C102.7,75.3,104.4,75.3,105.4,76.3L105.4,76.3L105.4,76.3z M41.4,82.2c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h12.4 c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H41.4L41.4,82.2L41.4,82.2z M45.1,112.3c1.7,0,3,1.4,3,3c0,1.7-1.4,3-3,3h-38 c-1.9,0-3.7-0.8-5-2.1c-1.3-1.3-2.1-3-2.1-5V7.1c0-2,0.8-3.7,2.1-5c1.3-1.3,3-2.1,5-2.1h86.7c1.9,0,3.7,0.8,5,2.1 c1.3,1.3,2.1,3,2.1,5v48.3c0,1.7-1.4,3-3,3c-1.7,0-3-1.4-3-3V7.1c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H7.1 c-0.3,0-0.5,0.1-0.7,0.3C6.2,6.5,6.1,6.8,6.1,7.1v104.3c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3H45.1L45.1,112.3L45.1,112.3 z M18.8,74.1h10.7c0.6,0,1,0.4,1,1v9.2c0,0.6-0.4,1-1,1H18.8c-0.6,0-1-0.4-1-1v-9.2C17.8,74.5,18.2,74.1,18.8,74.1L18.8,74.1 L18.8,74.1z M18.8,21.2h10.7c0.6,0,1,0.4,1,1v9.2c0,0.6-0.4,1-1,1H18.8c-0.6,0-1-0.4-1-1v-9.2C17.8,21.6,18.2,21.2,18.8,21.2 L18.8,21.2L18.8,21.2z M41.4,29.3c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h34.7c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H41.4 L41.4,29.3L41.4,29.3z M21.9,57.4c-0.7,0.5-1.6,0.4-2.3-0.3c-0.1-0.1-0.1-0.1-0.2-0.2l-3.2-3.3c-0.7-0.7-0.5-1.8,0.3-2.6 c0.9-0.7,2.1-0.8,2.8-0.1l1.7,1.8l5.6-4.5c0.7-0.6,1.9-0.3,2.5,0.6c0.7,0.9,0.6,2.2-0.2,2.8L21.9,57.4L21.9,57.4L21.9,57.4z M39.7,54.8c-1.4,0-2.5-1.4-2.5-3c0-1.7,1.1-3,2.5-3h34.7c1.4,0,2.5,1.4,2.5,3c0,1.7-1.1,3-2.5,3H39.7L39.7,54.8L39.7,54.8z M88.1,85.9c5.8,0,10.6,4.7,10.6,10.6c0,5.8-4.7,10.6-10.6,10.6c-5.8,0-10.6-4.7-10.6-10.6C77.5,90.6,82.3,85.9,88.1,85.9 L88.1,85.9L88.1,85.9z"/></svg>
export const SupportMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008z"
    />
  </svg>
);

export const DataObservabilityMenuSVG = (
  <span className="text-violet-500">
    {" "}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="w-6 h-6"
    >
      {" "}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
      />{" "}
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
      />{" "}
    </svg>{" "}
  </span>
);

export const ProfileDefaultAvatarSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={classname}
  >
    <path
      fillRule="evenodd"
      d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
      clipRule="evenodd"
    />
  </svg>
);

export const SwithRoleProfileMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
    />
  </svg>
);

export const SwitchGroupProfileMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
    />
  </svg>
);

export const ProfileDefaultOutlinedAvatarSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="w-5 h-5"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
);

export const BriefcaseSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={classname}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
    />
  </svg>
);

export const EnvelopeSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={classname}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
    />
  </svg>
);

export const OfficeSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={classname}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z"
    />
  </svg>
);

export const PhoneSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={classname}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
    />
  </svg>
);

export const SignOutProfileMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-5 h-5 mr-2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75"
    />
  </svg>
);

export const SideMenuToggleSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
    />
  </svg>
);

export const SideMenuExpandedToggleSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5M12 17.25h8.25"
    />
  </svg>
);

export const SideMenuCollapsedToggleSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-6 h-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
    />
  </svg>
);

export const CheckSVG = (classname: string) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className={classname}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 12.75l6 6 9-13.5"
    />
  </svg>
);

export const DataValidationSVG = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#FC9C90" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.4855 9.73763C13.228 10.0757 11.9787 10.4434 10.7386 10.8404C10.6264 10.875 10.5262 10.9406 10.4496 11.0296C10.373 11.1187 10.323 11.2275 10.3055 11.3436C9.5726 16.702 11.2638 20.6125 13.281 23.1879C14.293 24.4804 15.3888 25.4374 16.3018 26.0658C16.7597 26.3793 17.1626 26.6075 17.4802 26.7533C17.6397 26.8261 17.769 26.8756 17.868 26.9045C17.9116 26.9185 17.9562 26.9296 18.0013 26.9375C18.011 26.9361 18.0536 26.9306 18.1347 26.9059C18.2337 26.8756 18.363 26.8261 18.5225 26.7533C18.8387 26.6075 19.2443 26.3793 19.7008 26.0658C20.8457 25.2625 21.8639 24.2925 22.7217 23.1879C24.7388 20.6125 26.4301 16.702 25.6972 11.3436C25.6797 11.2275 25.6297 11.1187 25.5531 11.0296C25.4765 10.9406 25.3763 10.875 25.2641 10.8404C24.4033 10.5654 22.9513 10.1171 21.5172 9.73763C20.0515 9.35125 18.7026 9.0625 18.0013 9.0625C17.3001 9.0625 15.9526 9.35125 14.4855 9.73763ZM14.1335 8.40937C15.5676 8.02987 17.0897 7.6875 18.0013 7.6875C18.9116 7.6875 20.4351 8.02987 21.8692 8.40937C23.1484 8.75282 24.4192 9.12646 25.6807 9.53C26.4067 9.761 26.954 10.3866 27.0598 11.158C27.8477 16.9289 26.0203 21.2051 23.8052 24.0349C22.8613 25.2493 21.7406 26.3153 20.4805 27.1974C20.0423 27.5043 19.5791 27.7738 19.0958 28.0031C18.7246 28.1736 18.3286 28.3125 18.0013 28.3125C17.6741 28.3125 17.2781 28.1736 16.9068 28.0031C16.4234 27.774 15.9602 27.5045 15.5222 27.1974C14.2626 26.3152 13.1424 25.2492 12.1988 24.0349C9.98097 21.2051 8.15497 16.9289 8.94285 11.158C8.99552 10.7841 9.15301 10.4328 9.39708 10.1446C9.64115 9.85653 9.96182 9.64343 10.322 9.53C11.5835 9.12647 12.8543 8.75283 14.1335 8.40937V8.40937Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9251 15.4505C21.9891 15.5144 22.0399 15.5902 22.0745 15.6738C22.1092 15.7573 22.127 15.8468 22.127 15.9373C22.127 16.0277 22.1092 16.1172 22.0745 16.2008C22.0399 16.2843 21.9891 16.3602 21.9251 16.424L17.8001 20.549C17.7362 20.613 17.6603 20.6638 17.5768 20.6985C17.4933 20.7332 17.4037 20.751 17.3133 20.751C17.2229 20.751 17.1333 20.7332 17.0498 20.6985C16.9663 20.6638 16.8904 20.613 16.8266 20.549L14.7641 18.4865C14.7001 18.4226 14.6494 18.3467 14.6148 18.2632C14.5802 18.1797 14.5624 18.0902 14.5624 17.9998C14.5624 17.9094 14.5802 17.8199 14.6148 17.7363C14.6494 17.6528 14.7001 17.5769 14.7641 17.513C14.828 17.4491 14.9039 17.3984 14.9874 17.3638C15.0709 17.3292 15.1604 17.3114 15.2508 17.3114C15.3412 17.3114 15.4307 17.3292 15.5142 17.3638C15.5978 17.3984 15.6736 17.4491 15.7376 17.513L17.3133 19.0901L20.9516 15.4505C21.0154 15.3865 21.0913 15.3357 21.1748 15.301C21.2583 15.2664 21.3479 15.2485 21.4383 15.2485C21.5287 15.2485 21.6183 15.2664 21.7018 15.301C21.7853 15.3357 21.8612 15.3865 21.9251 15.4505V15.4505Z"
      fill="white"
    />
  </svg>
);

export const MetadataMonitoringSVG = (
  <svg
    width="128"
    height="128"
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_4197_914"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="128"
      height="128"
    >
      <rect width="128" height="128" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_4197_914)">
      <circle cx="64" cy="64" r="64" fill="#6451A2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.2417 39.7048C66.7222 34.6004 59.4224 34.6004 57.9028 39.7048L57.5349 40.9444C57.3078 41.7086 56.9111 42.4127 56.3737 43.0052C55.8363 43.5976 55.1718 44.0633 54.4292 44.3682C53.6865 44.6731 52.8843 44.8094 52.0816 44.7671C51.2788 44.7248 50.4958 44.5049 49.7899 44.1237L48.6493 43.5039C43.9288 40.959 38.7667 46.0743 41.3385 50.7485L41.9603 51.8824C43.6013 54.8721 42.0449 58.5947 38.752 59.5572L37.501 59.9218C32.3499 61.4276 32.3499 68.6613 37.501 70.167L38.752 70.5316C39.5231 70.7566 40.2337 71.1498 40.8316 71.6824C41.4294 72.2149 41.8994 72.8733 42.2071 73.6093C42.5147 74.3452 42.6523 75.1401 42.6096 75.9356C42.5669 76.7311 42.345 77.507 41.9603 78.2065L41.3348 79.3367C38.7667 84.0145 43.9288 89.1299 48.6456 86.5813L49.7899 85.9651C50.4958 85.5839 51.2788 85.3641 52.0816 85.3218C52.8843 85.2795 53.6865 85.4158 54.4292 85.7206C55.1718 86.0255 55.8363 86.4912 56.3737 87.0837C56.9111 87.6761 57.3078 88.3803 57.5349 89.1445L57.9028 90.3841C59.4224 95.4885 66.7222 95.4885 68.2417 90.3841L68.6096 89.1445C68.8367 88.3803 69.2335 87.6761 69.7709 87.0837C70.3083 86.4912 70.9727 86.0255 71.7154 85.7206C72.4581 85.4158 73.2602 85.2795 74.063 85.3218C74.8657 85.3641 75.6487 85.5839 76.3546 85.9651L77.4952 86.585C82.2158 89.1299 87.3779 84.0145 84.806 79.3404L84.1842 78.2065C83.7995 77.507 83.5777 76.7311 83.535 75.9356C83.4923 75.1401 83.6298 74.3452 83.9375 73.6093C84.2451 72.8733 84.7151 72.2149 85.313 71.6824C85.9108 71.1498 86.6214 70.7566 87.3926 70.5316L88.6435 70.167C93.7946 68.6613 93.7946 61.4276 88.6435 59.9218L87.3926 59.5572C86.6214 59.3322 85.9108 58.939 85.313 58.4065C84.7151 57.874 84.2451 57.2156 83.9375 56.4796C83.6298 55.7436 83.4923 54.9488 83.535 54.1533C83.5777 53.3578 83.7995 52.5819 84.1842 51.8824L84.8097 50.7521C87.3779 46.0743 82.2158 40.959 77.4989 43.5075L76.3546 44.1237C75.6487 44.5049 74.8657 44.7248 74.063 44.7671C73.2602 44.8094 72.4581 44.6731 71.7154 44.3682C70.9727 44.0633 70.3083 43.5976 69.7709 43.0052C69.2335 42.4127 68.8367 41.7086 68.6096 40.9444L68.2417 39.7048V39.7048ZM63.0723 75.7272C65.9314 75.7272 68.6734 74.6017 70.6952 72.5983C72.7169 70.5949 73.8527 67.8777 73.8527 65.0444C73.8527 62.2112 72.7169 59.494 70.6952 57.4906C68.6734 55.4872 65.9314 54.3617 63.0723 54.3617C60.2141 54.3617 57.473 55.4868 55.452 57.4895C53.4309 59.4922 52.2955 62.2085 52.2955 65.0408C52.2955 67.8731 53.4309 70.5893 55.452 72.5921C57.473 74.5948 60.2141 75.7199 63.0723 75.7199V75.7272Z"
        fill="#BABAF4"
      />
      <mask
        id="mask1_4197_914"
        maskUnits="userSpaceOnUse"
        x="27"
        y="25"
        width="119"
        height="120"
      >
        <rect
          width="46.6157"
          height="121.733"
          transform="matrix(0.717791 0.696258 -0.69577 0.718265 112.54 25.1067)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask1_4197_914)">
        <path
          d="M109.75 65.6989C109.75 90.8428 89.3817 111.217 64.2674 111.217C39.1531 111.217 18.7852 90.8428 18.7852 65.6989C18.7852 40.5551 39.1531 20.1807 64.2674 20.1807C89.3817 20.1807 109.75 40.5551 109.75 65.6989Z"
          stroke="#BABAF4"
          strokeWidth="15"
        />
      </g>
      <mask
        id="mask2_4197_914"
        maskUnits="userSpaceOnUse"
        x="-21"
        y="-13"
        width="119"
        height="120"
      >
        <rect
          width="46.6157"
          height="121.733"
          transform="matrix(0.717791 0.696258 -0.69577 0.718265 63.6982 -13)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask2_4197_914)">
        <path
          d="M108.922 64.0422C108.922 89.1861 88.5546 109.56 63.4402 109.56C38.3259 109.56 17.958 89.1861 17.958 64.0422C17.958 38.8983 38.3259 18.5239 63.4402 18.5239C88.5546 18.5239 108.922 38.8983 108.922 64.0422Z"
          stroke="#BABAF4"
          strokeWidth="15"
        />
      </g>
    </g>
  </svg>
);

export const SnowAlertSVG = (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="18" cy="18" r="18" fill="#29B5E8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.42 8.02811C15.0062 8.1187 14.6702 8.42737 14.5171 8.85746L14.4685 8.99405L14.4581 10.4984L14.4477 12.0027L13.2044 11.2635C12.4689 10.8262 11.9135 10.5092 11.8445 10.4873C11.4865 10.3738 11.1003 10.4198 10.8016 10.6118C10.5561 10.7695 10.3296 11.1122 10.2589 11.4331C10.1488 11.9321 10.3713 12.4647 10.7911 12.7074C10.8875 12.7631 15.0064 15.1718 15.156 15.2599C15.3023 15.3461 15.4882 15.3928 15.6851 15.3928C16.0351 15.3928 16.2951 15.2844 16.5418 15.0357C16.7221 14.8539 16.8157 14.6911 16.8754 14.4556C16.9153 14.2982 16.9166 14.2143 16.9163 11.6857C16.9159 8.79154 16.923 8.94511 16.7763 8.65999C16.5259 8.17331 15.9603 7.90982 15.42 8.02811ZM20.0418 8.02867C19.6009 8.12454 19.2169 8.50409 19.1157 8.94414C19.0893 9.05896 19.0845 9.46529 19.0827 11.7261L19.0806 14.3736L19.1356 14.5522C19.2006 14.7633 19.2962 14.914 19.46 15.0635C19.6864 15.2701 19.9636 15.3734 20.2918 15.3734C20.5098 15.3734 20.6738 15.3378 20.8345 15.2557C20.9151 15.2145 24.6894 13.0145 25.2266 12.6956C25.3627 12.6148 25.5533 12.4132 25.6312 12.2677C25.7086 12.123 25.7714 11.8663 25.7714 11.6943C25.7714 11.3927 25.6341 11.0481 25.4177 10.8065C25.1055 10.4579 24.6187 10.3354 24.152 10.488C24.0921 10.5076 23.4827 10.8474 22.7977 11.2431L21.5523 11.9626L21.5419 10.4783L21.5314 8.99405L21.4801 8.84695C21.2701 8.24392 20.6567 7.89498 20.0418 8.02867ZM8.95584 14.2591C8.71478 14.3167 8.45789 14.4772 8.31306 14.6607C8.13151 14.8906 8 15.2467 8 15.5083C8 15.7952 8.12936 16.124 8.31938 16.3203C8.45241 16.4578 8.34613 16.392 9.85911 17.2736C10.5096 17.6527 11.0393 17.9648 11.0363 17.9672C11.0332 17.9696 10.4729 18.2962 9.79107 18.693C8.5825 19.3964 8.54721 19.4187 8.38449 19.5838C8.12747 19.8446 8.02011 20.1038 8.02011 20.4638C8.02011 20.6768 8.05936 20.8533 8.14445 21.0228C8.44541 21.6222 9.04747 21.8729 9.66098 21.6543C9.76117 21.6186 9.86966 21.584 9.90206 21.5775C9.96227 21.5653 14.1385 19.1324 14.2706 19.0325C14.4431 18.9021 14.5675 18.7242 14.6557 18.4818C14.7026 18.353 14.7149 18.2782 14.7231 18.072C14.7352 17.7714 14.7045 17.6113 14.5914 17.3848C14.4381 17.0779 14.5058 17.123 12.0334 15.6795C10.809 14.9646 9.76777 14.3621 9.71967 14.3406C9.50596 14.2452 9.16567 14.209 8.95584 14.2591ZM26.4902 14.2653C26.4329 14.2803 26.342 14.3123 26.2882 14.3366C26.2344 14.3609 25.189 14.9654 23.9651 15.68C21.9166 16.8761 21.7291 16.9902 21.6044 17.1161C21.3674 17.3556 21.2696 17.6297 21.2681 18.0589C21.2675 18.2496 21.2768 18.3335 21.3106 18.4413C21.393 18.7045 21.5763 18.9285 21.8158 19.0588C21.8772 19.0921 22.8321 19.6489 23.9379 20.296C25.0437 20.9431 26.0282 21.5136 26.1256 21.5637C26.223 21.6139 26.3586 21.6692 26.4269 21.6865C26.5846 21.7265 26.8937 21.7266 27.0423 21.6867C27.4771 21.5702 27.8334 21.2109 27.949 20.7723C27.9888 20.621 27.9882 20.3091 27.9477 20.1523C27.8712 19.8559 27.6569 19.5621 27.3921 19.3906C27.3201 19.3439 26.7454 19.0056 26.1152 18.6388C25.4849 18.2721 24.9666 17.9697 24.9633 17.967C24.96 17.9642 25.4898 17.6519 26.1405 17.273C26.7912 16.894 27.3782 16.5512 27.4449 16.5113C27.7774 16.312 28 15.9099 28 15.5083C28 15.1319 27.7696 14.6729 27.4738 14.46C27.2625 14.308 27.0973 14.2533 26.8236 14.245C26.6811 14.2407 26.555 14.2484 26.4902 14.2653ZM17.6146 15.7063C17.5115 15.7551 15.7415 17.5391 15.7091 17.6269C15.6971 17.6594 15.6873 17.8324 15.6873 18.0112C15.6873 18.2911 15.6929 18.3473 15.7274 18.4144C15.7495 18.4572 16.1737 18.9004 16.6702 19.3992C17.4348 20.1674 17.5856 20.3096 17.6562 20.329C17.7641 20.3585 18.2359 20.3585 18.3438 20.329C18.4144 20.3096 18.563 20.1695 19.3153 19.4127C20.3526 18.3696 20.271 18.491 20.271 17.9905C20.271 17.7272 20.2647 17.6604 20.2345 17.6041C20.2145 17.5667 19.809 17.1328 19.3334 16.6398C18.7269 16.0111 18.4439 15.7321 18.3854 15.7052C18.2621 15.6485 17.7352 15.6492 17.6146 15.7063ZM18.4475 17.5067C18.9427 17.9772 18.9442 17.9971 18.5138 18.4362C18.2029 18.7535 18.146 18.797 18.0417 18.797C17.9373 18.797 17.8804 18.7535 17.5695 18.4362C17.1543 18.0125 17.1536 17.9873 17.5473 17.5824C17.8571 17.2638 17.9161 17.221 18.0452 17.221H18.1467L18.4475 17.5067ZM20.0225 20.6565C19.7775 20.7126 19.5938 20.8181 19.4051 21.0111C19.2713 21.1478 19.2253 21.2112 19.189 21.3092C19.0763 21.6129 19.0817 21.4607 19.0832 24.3059C19.0848 27.2271 19.0766 27.0477 19.2221 27.3481C19.3672 27.6477 19.707 27.9121 20.0351 27.9809C20.2157 28.0187 20.5861 27.9971 20.7324 27.9403C21.0003 27.8363 21.2604 27.6089 21.3836 27.3712C21.5372 27.0747 21.5293 27.1664 21.5414 25.5269L21.5523 24.0509L22.8024 24.7708C23.49 25.1668 24.1041 25.5082 24.1671 25.5295C24.3338 25.5858 24.6634 25.5985 24.834 25.5551C25.2424 25.4513 25.5661 25.1368 25.7083 24.7055C25.8821 24.1782 25.6735 23.5835 25.2193 23.3118C25.1505 23.2707 24.1333 22.6754 22.9588 21.9889C21.5186 21.1472 20.7761 20.7248 20.6783 20.6916C20.4933 20.6288 20.2096 20.6136 20.0225 20.6565ZM15.44 20.6895C15.3785 20.7006 15.2753 20.7313 15.2108 20.7578C15.1206 20.7949 12.6189 22.2468 10.812 23.3109C10.574 23.451 10.4307 23.5931 10.3273 23.7917C10.2199 23.9978 10.1802 24.1834 10.1931 24.4182C10.212 24.761 10.3394 25.0448 10.5861 25.2939C10.9247 25.6357 11.4592 25.7279 11.9058 25.5217C11.9746 25.4899 12.5746 25.1459 13.2392 24.7572L14.4477 24.0504L14.4591 25.5267C14.4715 27.1401 14.4666 27.0764 14.5986 27.3395C14.753 27.647 15.0426 27.8842 15.3684 27.9697C15.5232 28.0104 15.853 28.01 16.0092 27.969C16.1993 27.919 16.4124 27.7952 16.5545 27.6523C16.6972 27.5088 16.7732 27.3892 16.8524 27.1841L16.9062 27.045L16.9166 24.3762C16.9249 22.2366 16.9216 21.6845 16.9 21.5919C16.837 21.3219 16.5532 20.9731 16.2811 20.8314C16.2009 20.7896 16.0837 20.74 16.0207 20.7213C15.8777 20.6788 15.5878 20.6629 15.44 20.6895Z"
      fill="white"
    />
  </svg>
);

export const SchedulerMenuSVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    className="w-6 h-6"
    fill="#34d399"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 469 511.83"
  >
    <path
      fillRule="nonzero"
      d="M132.43 488.32c-.83-.41-1.6-.88-2.33-1.39-1.1-.32-2.2-.74-3.29-1.3a235.796 235.796 0 0 1-32.47-20.1c-10.56-7.82-9.1-24.17 2.7-29.99 5.92-2.96 13.05-2.28 18.36 1.65 8.7 6.43 17.89 12.08 27.51 17.02.9.47 1.75 1 2.53 1.58.84.26 1.67.59 2.49.98l.01-.03c17.55 8.48 35.74 14.15 54.04 17.19.82.01 1.65.07 2.5.2 3.27.5 6.54.95 9.83 1.3.69.09 1.36.2 2.01.35 28.62 2.63 57.2-1.03 83.82-10.32 48.12-16.78 89.85-51.93 113.77-101.46 23.92-49.54 25.51-104.08 8.72-152.21-16.78-48.12-51.93-89.85-101.46-113.77-17.3-8.35-35.2-13.98-53.21-17.04a198.53 198.53 0 0 0-42.83-2.58l3.85 3.57c7.95 7.35 8.43 19.75 1.08 27.7-7.36 7.95-19.76 8.43-27.71 1.08L162.11 73.5c-7.3-6.75-8.3-17.78-2.71-25.69.97-1.76 2.22-3.4 3.77-4.86l39.9-37.61c7.9-7.44 20.34-7.06 27.78.85 7.44 7.9 7.06 20.34-.85 27.78l-9.98 9.41c17.78-1.12 35.81-.21 53.73 2.84 21.26 3.62 42.36 10.25 62.73 20.08 58.27 28.15 99.64 77.26 119.39 133.91 19.75 56.65 17.9 120.82-10.24 179.1-28.14 58.27-77.25 99.63-133.9 119.39-56.65 19.75-120.82 17.9-179.1-10.24l.02-.03-.22-.11zm64.47-306.08c0-10.03 8.13-18.16 18.16-18.16s18.16 8.13 18.16 18.16v110.52l75.65 33.25c9.16 4.04 13.32 14.74 9.29 23.9-4.04 9.17-14.74 13.33-23.9 9.29l-85.58-37.61c-6.88-2.59-11.78-9.22-11.78-17.01V182.24zM41.35 411.05c8.85 12.7 28.65 8.66 31.79-6.53.95-4.86 0-9.53-2.79-13.62-6.2-9.02-11.52-18.1-16.23-27.99-4.71-9.88-17.01-13.15-26.03-6.95a17.653 17.653 0 0 0-5.88 22.05c5.56 11.67 11.82 22.39 19.14 33.04zM1.42 304.77c.86 7.41 6.01 13.31 13.22 15.2 11.98 2.99 23.17-6.8 21.88-19.05-1.21-10.78-1.49-21.55-.94-32.38a17.67 17.67 0 0 0-12-17.68C12.52 247.17.93 254.99.33 266.66c-.67 12.71-.32 25.45 1.09 38.11zm14.84-112.36c-5.36 13.61 7.38 27.49 21.42 23.37 5.24-1.53 9.46-5.43 11.45-10.5 3.93-10.12 8.67-19.83 14.17-29.19 3.31-5.74 3.28-12.47-.12-18.16-7.04-11.37-23.43-11.27-30.28.21a233.5 233.5 0 0 0-16.64 34.27zm65.37-92.63c-10.81 9.47-6.65 26.95 7.29 30.51 5.65 1.37 11.34-.01 15.76-3.76 8.27-7.12 16.88-13.39 26.17-19.1 5.29-3.23 8.38-8.85 8.45-15.02 0-13.8-15.09-22.29-26.86-15.11-10.9 6.67-21.12 14.16-30.81 22.48z"
    />
  </svg>
);

export const HeaderLogo = (classname: string) => (
  <svg
    className={classname}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37748 0.039231C6.2103 0.089702 6.02331 0.251246 5.93569 0.420896C5.87972 0.529258 5.87466 0.651429 5.86511 2.1275C5.85805 3.21251 5.86621 3.76807 5.89076 3.87699C5.93368 4.06734 6.09586 4.26461 6.29186 4.3649C6.41531 4.42805 6.47996 4.43445 7.09818 4.44448L7.7703 4.45543V5.12293V5.79046H7.11208C6.45823 5.79046 6.45272 5.79102 6.27823 5.87619C6.08113 5.97236 5.93708 6.14394 5.89025 6.33831C5.87402 6.40562 5.86041 6.76584 5.85999 7.13874L5.85921 7.81678H5.08182H4.30443L4.30372 7.07639C4.30294 6.24984 4.28891 6.18353 4.07354 5.98689C3.85555 5.78781 3.88104 5.79046 2.17949 5.79046C1.11631 5.79046 0.597111 5.80153 0.512117 5.82603C0.347892 5.87341 0.17285 6.01638 0.0845184 6.17537C0.0131603 6.3038 0.0125126 6.31808 0.00328111 7.95706C-0.00497868 9.42506 -0.000119748 9.6242 0.0469449 9.743C0.112505 9.9086 0.221663 10.036 0.37834 10.1297C0.491483 10.1974 0.538904 10.2025 1.19486 10.2172L1.89127 10.2328L1.90002 10.893L1.90873 11.5532L1.236 11.5632C0.614538 11.5725 0.552994 11.5785 0.429033 11.6424C0.253375 11.7328 0.0782673 11.9327 0.0311055 12.0967C0.003994 12.191 -0.00394198 12.6896 0.00295737 13.8671L0.0125775 15.5062L0.110594 15.6587C0.17136 15.7533 0.268955 15.8472 0.367198 15.9057L0.525753 16H2.14788C3.74804 16 3.77172 15.9991 3.89954 15.9327C3.9708 15.8957 4.06843 15.8255 4.11646 15.7769C4.30683 15.5838 4.30443 15.6093 4.30443 13.7769V12.0975L4.22909 11.96C4.13114 11.7814 3.92853 11.6345 3.72119 11.5917C3.63046 11.573 3.30188 11.5577 2.99099 11.5577H2.42573V10.8874V10.2172L3.08166 10.2165C3.64944 10.2159 3.75501 10.2081 3.86715 10.1584C4.03548 10.0838 4.1531 9.97519 4.23689 9.8171C4.29912 9.69973 4.30443 9.63726 4.30443 9.02157C4.30443 8.51409 4.31418 8.35061 4.34492 8.34169C4.3776 8.33222 5.75553 8.3344 5.83217 8.34403C5.84402 8.34553 5.8586 8.65188 5.86456 9.02478C5.87538 9.70117 5.87564 9.70316 5.9652 9.84984C6.06451 10.0124 6.20658 10.1277 6.3742 10.1817C6.44177 10.2035 6.73271 10.2172 7.1273 10.2172H7.7703V12.1309C7.7703 13.9686 7.77276 14.0476 7.8322 14.1183L7.8941 14.1919L9.78951 14.2004L11.6849 14.209L11.6954 14.8395C11.7049 15.4152 11.7119 15.4809 11.7758 15.5947C11.8659 15.7554 11.9977 15.8747 12.1553 15.9381C12.2656 15.9824 12.4726 15.9882 13.8533 15.9856C15.6071 15.9823 15.573 15.9862 15.7939 15.7622C15.9972 15.556 15.9977 15.5512 15.9977 13.7866C15.9977 12.0219 15.9971 12.0159 15.7939 11.8123C15.5943 11.6124 15.5653 11.606 14.783 11.5889L14.0704 11.5733L14.0617 10.8952L14.053 10.2172L14.7257 10.2169C15.3645 10.2166 15.4068 10.2129 15.5627 10.143C15.751 10.0586 15.9071 9.89298 15.9607 9.72084C16.0147 9.54754 16.0123 6.45297 15.9581 6.27728C15.906 6.10856 15.6672 5.87868 15.4919 5.82855C15.395 5.80087 14.9396 5.79055 13.8237 5.79077L12.2889 5.79108L12.1231 5.86534C11.9439 5.94568 11.805 6.09488 11.7359 6.28139C11.7047 6.36556 11.6921 6.59712 11.6911 7.10757L11.6897 7.81678H10.9285H10.1673L10.1665 7.07639C10.1658 6.24984 10.1517 6.18353 9.93638 5.98689C9.73928 5.80689 9.6557 5.79046 8.93743 5.79046H8.28856V5.12022V4.44997H8.85382C9.16472 4.44997 9.4933 4.43466 9.58402 4.41593C9.79136 4.37313 9.99397 4.2262 10.0919 4.04761L10.1673 3.91019V2.23071C10.1673 0.892063 10.1584 0.530848 10.1236 0.450886C10.059 0.302559 9.91749 0.154201 9.76639 0.0764216C9.63449 0.00852423 9.61314 0.00755787 8.07802 0.00144773C6.81599 -0.00360248 6.4958 0.00353658 6.37748 0.039231ZM9.81096 2.53585C9.81096 3.90916 9.80768 3.93235 9.60112 4.02672C9.44247 4.09917 6.5864 4.10085 6.44119 4.02859C6.24966 3.93326 6.24791 3.91979 6.24791 2.54991V1.30138H8.02943H9.81096V2.53585ZM3.94152 8.28439C3.95178 9.56949 3.94216 9.66937 3.79721 9.77907C3.71458 9.84164 3.67711 9.8431 2.16275 9.8431H0.612854L0.507063 9.75217L0.401274 9.66123L0.392139 8.36464L0.383005 7.06807L2.15747 7.07611L3.93193 7.08419L3.94152 8.28439ZM9.80296 8.33116C9.81086 9.53573 9.80892 9.58164 9.74556 9.68131C9.61849 9.88123 9.61249 9.88182 7.95458 9.85651L6.46483 9.83378L6.36445 9.74749L6.26411 9.66123L6.25497 8.36464L6.24584 7.06807L8.0203 7.07611L9.79476 7.08419L9.80296 8.33116ZM15.6343 8.36177L15.6252 9.6549L15.5193 9.75681L15.4135 9.85869L13.9392 9.86739C12.9571 9.87322 12.4215 9.86486 12.3349 9.84245C12.2444 9.81897 12.1858 9.77851 12.1418 9.70902C12.0818 9.61444 12.0786 9.54361 12.0785 8.33895L12.0784 7.0686H13.8609H15.6435L15.6343 8.36177ZM11.6953 9.00919C11.7054 9.64748 11.7119 9.71276 11.7758 9.82752C11.8651 9.98763 11.9617 10.073 12.1431 10.1522C12.2739 10.2093 12.3548 10.2159 12.9293 10.2165L13.5696 10.2172L13.5609 10.8952L13.5522 11.5733L12.8719 11.5889C12.1346 11.6058 12.0858 11.6163 11.912 11.7965C11.7124 12.0034 11.7068 12.0321 11.6953 12.906L11.6848 13.7087H9.98668H8.28856V11.9629V10.2172H8.93743C9.6557 10.2172 9.73928 10.2008 9.93638 10.0208C10.1477 9.82783 10.1657 9.74889 10.1665 9.0144C10.1669 8.6529 10.177 8.34777 10.1889 8.33636C10.2007 8.32492 10.5421 8.31557 10.9473 8.31557H11.6843L11.6953 9.00919ZM3.94139 14.1373C3.93115 15.5118 3.93439 15.4871 3.75144 15.5911C3.67325 15.6355 3.48645 15.6415 2.16809 15.6415C0.528312 15.6415 0.534531 15.6422 0.434215 15.4555C0.39269 15.3782 0.385078 15.1705 0.385078 14.1155V12.867H2.16796H3.95085L3.94139 14.1373ZM15.6414 14.1155C15.6414 15.1622 15.6336 15.3786 15.593 15.4541C15.4888 15.648 15.5498 15.6415 13.8494 15.6415H12.2986L12.1885 15.5355L12.0784 15.4295V14.1483V12.867H13.8599H15.6414V14.1155Z"
      fill="#198754"
    />
  </svg>
);
// width="259" height="50"
export const HeaderNavLogo = (
  <svg
    className="w-[259px] h-[50px]"
    viewBox="0 0 259 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_16_35)">
      <path
        d="M24.417 29.2834C27.114 29.2834 29.3003 27.0983 29.3003 24.4028C29.3003 21.7074 27.114 19.5223 24.417 19.5223C21.7199 19.5223 19.5336 21.7074 19.5336 24.4028C19.5336 27.0983 21.7199 29.2834 24.417 29.2834Z"
        fill="#FFD000"
      />
      <path
        d="M24.4457 48.8114C18.0398 48.8114 11.7776 46.2965 7.14124 41.6628C-2.38424 32.1429 -2.38424 16.6571 7.14124 7.13712C16.6667 -2.38286 32.1671 -2.38286 41.6869 7.13712C47.8802 13.3268 50.2874 22.4219 47.9721 30.8739C47.6159 32.1716 46.2715 32.941 44.9731 32.585C43.6747 32.229 42.9048 30.8854 43.261 29.5877C45.1167 22.8238 43.1864 15.5489 38.234 10.5937C30.616 2.98002 18.2179 2.98002 10.5941 10.5937C2.976 18.2074 2.976 30.5983 10.5941 38.2177C15.5464 43.1672 22.8313 45.0965 29.5991 43.2418C30.8975 42.8859 32.2418 43.6495 32.598 44.9529C32.9542 46.2506 32.1901 47.5942 30.886 47.9502C28.7603 48.5301 26.5943 48.8172 24.4399 48.8172L24.4457 48.8114Z"
        fill="#0FB6CC"
      />
      <path
        d="M48.5983 41.6686C48.4317 41.5021 48.2479 41.3528 48.0641 41.215L36.5508 32.6079C40.4058 26.912 39.814 19.0859 34.7755 14.0446C29.0591 8.33142 19.7634 8.33142 14.047 14.0446C8.33054 19.7577 8.33054 29.048 14.047 34.7611C16.9023 37.6148 20.6596 39.0446 24.4112 39.0446C27.2838 39.0446 30.1506 38.2062 32.6211 36.5354L41.2273 48.042C41.3652 48.22 41.5146 48.4038 41.6812 48.5703C43.5886 50.4766 46.6795 50.4766 48.5926 48.5703C50.5057 46.664 50.5 43.5749 48.5926 41.6628L48.5983 41.6686ZM17.5056 31.3103C13.6965 27.5034 13.6965 21.308 17.5056 17.5011C19.4129 15.5949 21.9121 14.6475 24.417 14.6475C26.9219 14.6475 29.421 15.6006 31.3284 17.5011C35.1374 21.308 35.1374 27.5034 31.3284 31.3103C27.5194 35.1171 21.3203 35.1171 17.5113 31.3103H17.5056Z"
        fill="#E7314C"
      />
      <path
        d="M83.1439 24.4028C83.1439 32.1543 78.1916 37.833 70.2863 37.833H58.6179V10.9727H70.2863C78.1169 10.9727 83.1439 16.4963 83.1439 24.4028ZM77.8469 24.288C77.8469 19.1835 74.7732 15.6925 70.1714 15.6925H63.8402V33.073H70.1714C74.779 33.073 77.8469 29.4671 77.8469 24.288Z"
        fill="white"
      />
      <path
        d="M85.3616 28.1235C85.3616 22.2152 89.5843 17.8801 94.956 17.8801C97.6792 17.8801 99.8336 18.994 101.212 20.7567V18.4141H106.32V37.8272H101.212V35.4501C99.8279 37.2129 97.6792 38.367 94.956 38.367C89.5843 38.367 85.3616 33.9917 85.3616 28.1235ZM101.368 28.0833C101.368 24.7473 98.9087 22.4046 95.8407 22.4046C92.7728 22.4046 90.3886 24.7473 90.3886 28.0833C90.3886 31.4193 92.6522 33.8367 95.8407 33.8367C99.0293 33.8367 101.368 31.4595 101.368 28.0833Z"
        fill="white"
      />
      <path
        d="M122.883 37.2186C121.349 37.833 119.965 38.1373 118.356 38.1373C113.904 38.1373 111.87 35.3755 111.87 31.1954V22.8698H108.607V18.4198H111.87V12.1268H116.977V18.4198H122.659V22.8698H116.977V31.1954C116.977 32.7687 117.747 33.653 119.356 33.653C120.24 33.653 120.89 33.4979 121.66 33.1132L122.889 37.2186H122.883Z"
        fill="white"
      />
      <path
        d="M124.009 28.1235C124.009 22.2152 128.232 17.8801 133.604 17.8801C136.327 17.8801 138.481 18.994 139.86 20.7567V18.4141H144.968V37.8272H139.86V35.4501C138.476 37.2129 136.327 38.367 133.604 38.367C128.232 38.367 124.009 33.9917 124.009 28.1235ZM140.015 28.0833C140.015 24.7473 137.556 22.4046 134.488 22.4046C131.421 22.4046 129.036 24.7473 129.036 28.0833C129.036 31.4193 131.3 33.8367 134.488 33.8367C137.677 33.8367 140.015 31.4595 140.015 28.0833Z"
        fill="white"
      />
      <path
        d="M160.479 28.4336H154.757V37.833H149.535V10.9727H162.622C168.46 10.9727 171.838 15.4628 171.838 19.7175C171.838 23.2487 169.764 26.5847 165.966 27.8881L172.648 37.8273H166.581L160.479 28.4279V28.4336ZM154.757 23.8286H162.283C165.007 23.8286 166.736 21.9511 166.736 19.7232C166.736 17.4954 164.972 15.6925 162.473 15.6925H154.757V23.8229V23.8286Z"
        fill="white"
      />
      <path
        d="M173.889 28.1235C173.889 22.2152 178.111 17.8801 183.483 17.8801C186.206 17.8801 188.361 18.994 189.74 20.7567V18.4141H194.847V37.8272H189.74V35.4501C188.355 37.2129 186.206 38.367 183.483 38.367C178.111 38.367 173.889 33.9917 173.889 28.1235ZM189.895 28.0833C189.895 24.7473 187.436 22.4046 184.368 22.4046C181.3 22.4046 178.916 24.7473 178.916 28.0833C178.916 31.4193 181.179 33.8367 184.368 33.8367C187.556 33.8367 189.895 31.4595 189.895 28.0833Z"
        fill="white"
      />
      <path
        d="M219.011 9.82428V37.833H213.904V35.4559C212.519 37.2186 210.37 38.3727 207.647 38.3727C202.276 38.3727 198.053 33.9975 198.053 28.1293C198.053 22.2611 202.276 17.8858 207.647 17.8858C210.37 17.8858 212.525 18.9998 213.904 20.7625V9.83002H219.011V9.82428ZM214.059 28.0834C214.059 24.7473 211.6 22.4047 208.532 22.4047C205.464 22.4047 203.08 24.7473 203.08 28.0834C203.08 31.4194 205.343 33.8367 208.532 33.8367C211.721 33.8367 214.059 31.4596 214.059 28.0834Z"
        fill="white"
      />
      <path
        d="M222.211 28.1235C222.211 22.2152 226.434 17.8801 231.806 17.8801C234.529 17.8801 236.683 18.994 238.062 20.7567V18.4141H243.17V37.8272H238.062V35.4501C236.678 37.2129 234.529 38.367 231.806 38.367C226.434 38.367 222.211 33.9917 222.211 28.1235ZM238.217 28.0833C238.217 24.7473 235.758 22.4046 232.69 22.4046C229.622 22.4046 227.238 24.7473 227.238 28.0833C227.238 31.4193 229.502 33.8367 232.69 33.8367C235.879 33.8367 238.217 31.4595 238.217 28.0833Z"
        fill="white"
      />
      <path
        d="M258.929 18.15V22.9099C254.781 22.2554 252.517 24.1789 252.517 29.3925V37.833H247.45V18.4198H252.517V21.2965C253.666 19.0342 255.895 17.7308 258.929 18.15Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_16_35">
        <rect width="258.929" height="50" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const SMSIcon = (
  <svg
    className="w-24 h-20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2H20.4C23.7603 2 25.4405 2 26.7239 2.65396C27.8529 3.2292 28.7708 4.14708 29.346 5.27606C30 6.55953 30 8.23969 30 11.6V20.4C30 23.7603 30 25.4405 29.346 26.7239C28.7708 27.8529 27.8529 28.7708 26.7239 29.346C25.4405 30 23.7603 30 20.4 30H11.6C8.23969 30 6.55953 30 5.27606 29.346C4.14708 28.7708 3.2292 27.8529 2.65396 26.7239C2 25.4405 2 23.7603 2 20.4V11.6Z"
      fill="url(#paint0_linear_87_7269)"
    />
    <path
      d="M16 23C20.9706 23 25 19.6421 25 15.5C25 11.3579 20.9706 8 16 8C11.0294 8 7 11.3579 7 15.5C7 18.1255 8.61889 20.4359 11.0702 21.7758C10.9881 22.4427 10.7415 23.3327 10 24C11.4021 23.7476 12.5211 23.2405 13.3571 22.6714C14.1928 22.885 15.0803 23 16 23Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_87_7269"
        x1="16"
        y1="2"
        x2="16"
        y2="30"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#5AF575" />
        <stop offset="1" stopColor="#13BD2C" />
      </linearGradient>
    </defs>
  </svg>
);
export const GMailIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-24 h-20"
    data-name="Layer 1"
    viewBox="0 0 32 32"
    id="gmail"
  >
    <path
      fill="#ea4435"
      d="M16.58,19.1068l-12.69-8.0757A3,3,0,0,1,7.1109,5.97l9.31,5.9243L24.78,6.0428A3,3,0,0,1,28.22,10.9579Z"
    ></path>
    <path
      fill="#00ac47"
      d="M25.5,5.5h4a0,0,0,0,1,0,0v18a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3V7.5a2,2,0,0,1,2-2Z"
      transform="rotate(180 26.5 16)"
    ></path>
    <path
      fill="#ffba00"
      d="M29.4562,8.0656c-.0088-.06-.0081-.1213-.0206-.1812-.0192-.0918-.0549-.1766-.0823-.2652a2.9312,2.9312,0,0,0-.0958-.2993c-.02-.0475-.0508-.0892-.0735-.1354A2.9838,2.9838,0,0,0,28.9686,6.8c-.04-.0581-.09-.1076-.1342-.1626a3.0282,3.0282,0,0,0-.2455-.2849c-.0665-.0647-.1423-.1188-.2146-.1771a3.02,3.02,0,0,0-.24-.1857c-.0793-.0518-.1661-.0917-.25-.1359-.0884-.0461-.175-.0963-.267-.1331-.0889-.0358-.1837-.0586-.2766-.0859s-.1853-.06-.2807-.0777a3.0543,3.0543,0,0,0-.357-.036c-.0759-.0053-.1511-.0186-.2273-.018a2.9778,2.9778,0,0,0-.4219.0425c-.0563.0084-.113.0077-.1689.0193a33.211,33.211,0,0,0-.5645.178c-.0515.022-.0966.0547-.1465.0795A2.901,2.901,0,0,0,23.5,8.5v5.762l4.72-3.3043a2.8878,2.8878,0,0,0,1.2359-2.8923Z"
    ></path>
    <path
      fill="#4285f4"
      d="M5.5,5.5h0a3,3,0,0,1,3,3v18a0,0,0,0,1,0,0h-4a2,2,0,0,1-2-2V8.5a3,3,0,0,1,3-3Z"
    ></path>
    <path
      fill="#c52528"
      d="M2.5439,8.0656c.0088-.06.0081-.1213.0206-.1812.0192-.0918.0549-.1766.0823-.2652A2.9312,2.9312,0,0,1,2.7426,7.32c.02-.0475.0508-.0892.0736-.1354A2.9719,2.9719,0,0,1,3.0316,6.8c.04-.0581.09-.1076.1342-.1626a3.0272,3.0272,0,0,1,.2454-.2849c.0665-.0647.1423-.1188.2147-.1771a3.0005,3.0005,0,0,1,.24-.1857c.0793-.0518.1661-.0917.25-.1359A2.9747,2.9747,0,0,1,4.3829,5.72c.089-.0358.1838-.0586.2766-.0859s.1853-.06.2807-.0777a3.0565,3.0565,0,0,1,.357-.036c.076-.0053.1511-.0186.2273-.018a2.9763,2.9763,0,0,1,.4219.0425c.0563.0084.113.0077.169.0193a2.9056,2.9056,0,0,1,.286.0888,2.9157,2.9157,0,0,1,.2785.0892c.0514.022.0965.0547.1465.0795a2.9745,2.9745,0,0,1,.3742.21A2.9943,2.9943,0,0,1,8.5,8.5v5.762L3.78,10.9579A2.8891,2.8891,0,0,1,2.5439,8.0656Z"
    ></path>
  </svg>
);
export const OutLookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-24 h-20"
    fill="none"
    viewBox="0 0 48 48"
    id="outlook"
  >
    <path
      fill="#0A2767"
      d="M47.9999 25.4418C48.0026 25.0665 47.8086 24.7172 47.4887 24.5209H47.4831L47.463 24.5097L30.8305 14.6642C30.7586 14.6156 30.6841 14.5713 30.6072 14.5313C29.965 14.2 29.2021 14.2 28.5599 14.5313C28.483 14.5713 28.4085 14.6156 28.3367 14.6642L11.7042 24.5097L11.6841 24.5209C11.1757 24.837 11.0199 25.5054 11.336 26.0137C11.4292 26.1635 11.5574 26.2883 11.7097 26.3773L28.3423 36.2228C28.4144 36.2709 28.4889 36.3153 28.5656 36.3557C29.2078 36.687 29.9706 36.687 30.6128 36.3557C30.6895 36.3153 30.764 36.271 30.8361 36.2228L47.4686 26.3773C47.8009 26.1835 48.0037 25.8265 47.9999 25.4418Z"
    ></path>
    <path
      fill="#0364B8"
      d="M13.6431 18.8681H24.5581V28.8733H13.6431V18.8681ZM45.7674 8.69767V4.12092C45.7936 2.97663 44.8879 2.02742 43.7436 2H15.4192C14.2749 2.02742 13.3691 2.97663 13.3953 4.12092V8.69767L30.1395 13.1628L45.7674 8.69767Z"
    ></path>
    <path
      fill="#0078D4"
      d="M13.3953 8.69763H24.5581V18.7441H13.3953V8.69763Z"
    ></path>
    <path
      fill="#28A8EA"
      d="M35.7209 8.69763H24.5581V18.7441L35.7209 28.7906H45.7674V18.7441L35.7209 8.69763Z"
    ></path>
    <path
      fill="#0078D4"
      d="M24.5581 18.7441H35.7209V28.7906H24.5581V18.7441Z"
    ></path>
    <path
      fill="#0364B8"
      d="M24.5581 28.7906H35.7209V38.8372H24.5581V28.7906Z"
    ></path>
    <path
      fill="#14447D"
      d="M13.6431 28.8733H24.5581V37.9687H13.6431V28.8733Z"
    ></path>
    <path
      fill="#0078D4"
      d="M35.7209 28.7906H45.7674V38.8372H35.7209V28.7906Z"
    ></path>
    <path
      fill="url(#paint0_linear_147648_937)"
      d="M47.4887 26.3159L47.4675 26.3271L30.8349 35.6815C30.7624 35.7262 30.6887 35.7686 30.6117 35.8065C30.3292 35.9411 30.0224 36.017 29.7097 36.0298L28.8011 35.4984C28.7243 35.4599 28.6497 35.417 28.5778 35.3701L11.722 25.75H11.7142L11.1628 25.4419V44.3784C11.1714 45.6419 12.2022 46.6592 13.4656 46.6512H45.7328C45.7518 46.6512 45.7685 46.6423 45.7886 46.6423C46.0554 46.6252 46.3185 46.5703 46.57 46.4793C46.6786 46.4333 46.7835 46.3788 46.8837 46.3163C46.9584 46.2739 47.0868 46.1813 47.0868 46.1813C47.6586 45.7581 47.9971 45.0898 47.9999 44.3785V25.4419C47.9996 25.8041 47.8042 26.1381 47.4887 26.3159Z"
    ></path>
    <path
      fill="#0A2767"
      d="M47.1069 25.367V26.5279L29.7153 38.5023L11.7098 25.7577C11.7098 25.7515 11.7047 25.7465 11.6986 25.7465L10.0465 24.7531V23.9158L10.7274 23.9047L12.1674 24.7307L12.2009 24.7419L12.3237 24.82C12.3237 24.82 29.2464 34.4758 29.2911 34.4981L29.9385 34.8777C29.9944 34.8553 30.0502 34.833 30.1171 34.8107C30.1506 34.7884 46.9171 25.3558 46.9171 25.3558L47.1069 25.367Z"
      opacity=".5"
    ></path>
    <path
      fill="#1490DF"
      d="M47.4887 26.3159L47.4675 26.3282L30.8349 35.6826C30.7624 35.7273 30.6887 35.7697 30.6117 35.8076C29.9657 36.1232 29.2104 36.1232 28.5644 35.8076C28.4879 35.7698 28.4134 35.728 28.3411 35.6826L11.7086 26.3282L11.6886 26.3159C11.3674 26.1418 11.1661 25.8072 11.1628 25.4419V44.3784C11.1708 45.6416 12.2013 46.6592 13.4645 46.6512C13.4645 46.6512 13.4645 46.6512 13.4646 46.6512H45.6982C46.9614 46.6592 47.9919 45.6417 48 44.3785C48 44.3785 48 44.3785 48 44.3784V25.4419C47.9996 25.8041 47.8042 26.1381 47.4887 26.3159Z"
    ></path>
    <path
      fill="#000"
      d="M31.0772 35.5442L30.8283 35.6837C30.7561 35.7297 30.6816 35.7718 30.605 35.8099C30.3307 35.9445 30.0325 36.0234 29.7276 36.042L36.0558 43.5256L47.0947 46.1857C47.3972 45.9572 47.6378 45.6567 47.7946 45.3116L31.0772 35.5442Z"
      opacity=".1"
    ></path>
    <path
      fill="#000"
      d="M32.2046 34.9102L30.8283 35.6837C30.7561 35.7297 30.6816 35.7718 30.605 35.8099C30.3307 35.9445 30.0325 36.0234 29.7276 36.042L32.6924 44.2166L47.098 46.1823C47.6655 45.7562 47.9996 45.0881 47.9999 44.3784V44.1339L32.2046 34.9102Z"
      opacity=".05"
    ></path>
    <path
      fill="#28A8EA"
      d="M13.4958 46.6512H45.6948C46.1903 46.6537 46.6735 46.4972 47.0734 46.2047L28.8 35.5007C28.7232 35.4622 28.6486 35.4193 28.5767 35.3723L11.7209 25.7522H11.7131L11.1628 25.4419V44.3137C11.1615 45.6034 12.2061 46.6499 13.4958 46.6512C13.4958 46.6512 13.4958 46.6512 13.4958 46.6512Z"
    ></path>
    <path
      fill="#000"
      d="M26.7907 12.9764V36.7867C26.7887 37.6215 26.2811 38.3718 25.507 38.6843C25.2671 38.7874 25.0089 38.8406 24.7479 38.8406H11.1628V12.0466H13.3953V10.9303H24.7479C25.8756 10.9346 26.7882 11.8487 26.7907 12.9764Z"
      opacity=".1"
    ></path>
    <path
      fill="#000"
      d="M25.6744 14.0926V37.9028C25.6772 38.1725 25.62 38.4394 25.507 38.6842C25.1969 39.4483 24.4562 39.9496 23.6316 39.9534H11.1628V12.0465H23.6316C23.9555 12.0432 24.2747 12.124 24.5581 12.2809C25.2424 12.6257 25.6741 13.3264 25.6744 14.0926Z"
      opacity=".2"
    ></path>
    <path
      fill="#000"
      d="M25.6744 14.0926V35.6703C25.669 36.7975 24.7588 37.7111 23.6316 37.7209H11.1628V12.0465H23.6316C23.9555 12.0432 24.2747 12.124 24.5581 12.2809C25.2424 12.6257 25.6741 13.3264 25.6744 14.0926Z"
      opacity=".2"
    ></path>
    <path
      fill="#000"
      d="M24.5581 14.0926V35.6703C24.5569 36.7993 23.6443 37.7154 22.5153 37.7209H11.1628V12.0465H22.5153C23.6441 12.0471 24.5587 12.9627 24.5581 14.0915C24.5581 14.0919 24.5581 14.0923 24.5581 14.0926Z"
      opacity=".2"
    ></path>
    <path
      fill="url(#paint1_linear_147648_937)"
      d="M2.04613 12.0465H22.512C23.642 12.0465 24.5581 12.9626 24.5581 14.0926V34.5585C24.5581 35.6885 23.642 36.6046 22.512 36.6046H2.04613C0.916073 36.6046 0 35.6885 0 34.5585V14.0926C0 12.9626 0.916099 12.0465 2.04613 12.0465Z"
    ></path>
    <path
      fill="#fff"
      d="M6.39515 20.6285C6.89945 19.5541 7.71345 18.6549 8.73265 18.0466C9.86134 17.4004 11.1465 17.0782 12.4465 17.1156C13.6514 17.0895 14.8404 17.3949 15.8835 17.9986C16.8643 18.5834 17.6542 19.4404 18.1574 20.4655C18.7054 21.5951 18.9785 22.8382 18.9544 24.0934C18.981 25.4053 18.7 26.7051 18.1339 27.8888C17.6188 28.9505 16.8038 29.838 15.7898 30.4417C14.7064 31.0639 13.4733 31.3773 12.2244 31.3481C10.9937 31.3778 9.77853 31.0689 8.71144 30.4551C7.72218 29.8694 6.92237 29.0115 6.40744 27.9836C5.85622 26.8704 5.57987 25.6413 5.6015 24.3993C5.57853 23.0986 5.84985 21.8096 6.39515 20.6285ZM8.88668 26.6899C9.15556 27.3692 9.61153 27.9583 10.2017 28.3889C10.8027 28.809 11.5225 29.0257 12.2556 29.0073C13.0363 29.0382 13.8059 28.814 14.448 28.3688C15.0306 27.9395 15.4746 27.3488 15.725 26.6698C16.0049 25.9115 16.143 25.1082 16.1324 24.2999C16.1411 23.484 16.0112 22.6725 15.7484 21.9C15.5163 21.2025 15.0866 20.5874 14.5116 20.1295C13.8856 19.6632 13.1181 19.4267 12.3382 19.4598C11.5892 19.4404 10.8533 19.6588 10.2363 20.0838C9.63614 20.5162 9.17152 21.1105 8.89672 21.7972C8.28712 23.3714 8.28395 25.1158 8.88778 26.6921L8.88668 26.6899Z"
    ></path>
    <path
      fill="#50D9FF"
      d="M35.7209 8.69763H45.7674V18.7441H35.7209V8.69763Z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_147648_937"
        x1="29.581"
        x2="29.581"
        y1="25.442"
        y2="46.651"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1"></stop>
        <stop offset="1" stopColor="#28A8EA"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_147648_937"
        x1="4.266"
        x2="20.292"
        y1="10.448"
        y2="38.203"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9"></stop>
        <stop offset=".5" stopColor="#107AD5"></stop>
        <stop offset="1" stopColor="#0A63C9"></stop>
      </linearGradient>
    </defs>
  </svg>
);
export const SlackIcon = (
  <svg
    className="w-24 h-20"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        fill="#E01E5A"
        d="M2.471 11.318a1.474 1.474 0 001.47-1.471v-1.47h-1.47A1.474 1.474 0 001 9.846c.001.811.659 1.469 1.47 1.47zm3.682-2.942a1.474 1.474 0 00-1.47 1.471v3.683c.002.811.66 1.468 1.47 1.47a1.474 1.474 0 001.47-1.47V9.846a1.474 1.474 0 00-1.47-1.47z"
      />

      <path
        fill="#36C5F0"
        d="M4.683 2.471c.001.811.659 1.469 1.47 1.47h1.47v-1.47A1.474 1.474 0 006.154 1a1.474 1.474 0 00-1.47 1.47zm2.94 3.682a1.474 1.474 0 00-1.47-1.47H2.47A1.474 1.474 0 001 6.153c.002.812.66 1.469 1.47 1.47h3.684a1.474 1.474 0 001.47-1.47z"
      />

      <path
        fill="#2EB67D"
        d="M9.847 7.624a1.474 1.474 0 001.47-1.47V2.47A1.474 1.474 0 009.848 1a1.474 1.474 0 00-1.47 1.47v3.684c.002.81.659 1.468 1.47 1.47zm3.682-2.941a1.474 1.474 0 00-1.47 1.47v1.47h1.47A1.474 1.474 0 0015 6.154a1.474 1.474 0 00-1.47-1.47z"
      />

      <path
        fill="#ECB22E"
        d="M8.377 9.847c.002.811.659 1.469 1.47 1.47h3.683A1.474 1.474 0 0015 9.848a1.474 1.474 0 00-1.47-1.47H9.847a1.474 1.474 0 00-1.47 1.47zm2.94 3.682a1.474 1.474 0 00-1.47-1.47h-1.47v1.47c.002.812.659 1.469 1.47 1.47a1.474 1.474 0 001.47-1.47z"
      />
    </g>
  </svg>
);
export const TeamsIcon = (
  <svg
    className="w-24 h-20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 13.9032C19 13.4044 19.4044 13 19.9032 13H31.0968C31.5956 13 32 13.4044 32 13.9032V20.5C32 24.0899 29.0899 27 25.5 27C21.9101 27 19 24.0899 19 20.5V13.9032Z"
      fill="url(#paint0_linear_87_7777)"
    />
    <path
      d="M9 12.2258C9 11.5488 9.54881 11 10.2258 11H23.7742C24.4512 11 25 11.5488 25 12.2258V22C25 26.4183 21.4183 30 17 30C12.5817 30 9 26.4183 9 22V12.2258Z"
      fill="url(#paint1_linear_87_7777)"
    />
    <circle cx="27" cy="8" r="3" fill="#34439E" />
    <circle cx="27" cy="8" r="3" fill="url(#paint2_linear_87_7777)" />
    <circle cx="18" cy="6" r="4" fill="url(#paint3_linear_87_7777)" />
    <mask
      id="mask0_87_7777"
      maskUnits="userSpaceOnUse"
      x="9"
      y="0"
      width="16"
      height="30"
    >
      <path
        d="M17 10C19.7615 10 22 7.76147 22 5C22 2.23853 19.7615 0 17 0C14.2385 0 12 2.23853 12 5C12 7.76147 14.2385 10 17 10Z"
        fill="url(#paint4_linear_87_7777)"
      />
      <path
        d="M10.2258 11C9.54883 11 9 11.5488 9 12.2258V22C9 26.4183 12.5817 30 17 30C21.4183 30 25 26.4183 25 22V12.2258C25 11.5488 24.4512 11 23.7742 11H10.2258Z"
        fill="url(#paint5_linear_87_7777)"
      />
    </mask>
    <g mask="url(#mask0_87_7777)">
      <path
        d="M7 12C7 10.3431 8.34315 9 10 9H17C18.6569 9 20 10.3431 20 12V24C20 25.6569 18.6569 27 17 27H7V12Z"
        fill="#000000"
        fillOpacity="0.3"
      />
    </g>
    <rect
      y="7"
      width="18"
      height="18"
      rx="2"
      fill="url(#paint6_linear_87_7777)"
    />
    <path d="M13 11H5V12.8347H7.99494V21H10.0051V12.8347H13V11Z" fill="white" />
    <defs>
      <linearGradient
        id="paint0_linear_87_7777"
        x1="19"
        y1="13.7368"
        x2="32.1591"
        y2="22.3355"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#364088" />
        <stop offset="1" stopColor="#6E7EE1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_87_7777"
        x1="9"
        y1="19.4038"
        x2="25"
        y2="19.4038"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#515FC4" />
        <stop offset="1" stopColor="#7084EA" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_87_7777"
        x1="24"
        y1="5.31579"
        x2="29.7963"
        y2="9.39469"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#364088" />
        <stop offset="1" stopColor="#6E7EE1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_87_7777"
        x1="15.1429"
        y1="3.14286"
        x2="20.2857"
        y2="9.14286"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4858AE" />
        <stop offset="1" stopColor="#4E60CE" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_87_7777"
        x1="13.4286"
        y1="1.42857"
        x2="19.8571"
        y2="8.92857"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4858AE" />
        <stop offset="1" stopColor="#4E60CE" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_87_7777"
        x1="13.4286"
        y1="1.42857"
        x2="19.8571"
        y2="8.92857"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4858AE" />
        <stop offset="1" stopColor="#4E60CE" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_87_7777"
        x1="-5.21539e-08"
        y1="16"
        x2="18"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2A3887" />
        <stop offset="1" stopColor="#4C56B9" />
      </linearGradient>
    </defs>
  </svg>
);

export const EMailIcon = (
  <svg
    className="w-24 h-20"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="6" width="48" height="36" rx="2" ry="2" fill="#38b1e7" />
    <path
      d="M47.84,40.56A2.11,2.11,0,0,1,46,41.9L2,42H2A2,2,0,0,1,.15,40.78a2,2,0,0,1,.44-2.16L17.88,21.73a9.23,9.23,0,0,1,12.56.07L47.4,38.41A2,2,0,0,1,47.84,40.56Z"
      fill="#299acc"
    />
    <path
      d="M47.84,7.44A2.11,2.11,0,0,0,46,6.1L2,6H2A2,2,0,0,0,.15,7.22,2,2,0,0,0,.59,9.38L17.88,26.27a9.23,9.23,0,0,0,12.56-.07L47.4,9.59A2,2,0,0,0,47.84,7.44Z"
      fill="#6ac1e7"
    />
  </svg>
);

export const PhoneCallIcon = (
  <svg
    fill="#40C057"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 50 50"
    className="w-24 h-20"
  >
    <path d="M 14 3.9902344 C 8.4886661 3.9902344 4 8.4789008 4 13.990234 L 4 35.990234 C 4 41.501568 8.4886661 45.990234 14 45.990234 L 36 45.990234 C 41.511334 45.990234 46 41.501568 46 35.990234 L 46 13.990234 C 46 8.4789008 41.511334 3.9902344 36 3.9902344 L 14 3.9902344 z M 18.005859 12.033203 C 18.633859 12.060203 19.210594 12.414031 19.558594 12.957031 C 19.954594 13.575031 20.569141 14.534156 21.369141 15.785156 C 22.099141 16.926156 22.150047 18.399844 21.498047 19.589844 L 20.033203 21.673828 C 19.637203 22.237828 19.558219 22.959703 19.824219 23.595703 C 20.238219 24.585703 21.040797 26.107203 22.466797 27.533203 C 23.892797 28.959203 25.414297 29.761781 26.404297 30.175781 C 27.040297 30.441781 27.762172 30.362797 28.326172 29.966797 L 30.410156 28.501953 C 31.600156 27.849953 33.073844 27.901859 34.214844 28.630859 C 35.465844 29.430859 36.424969 30.045406 37.042969 30.441406 C 37.585969 30.789406 37.939797 31.366141 37.966797 31.994141 C 38.120797 35.558141 35.359641 37.001953 34.556641 37.001953 C 34.000641 37.001953 27.316344 37.761656 19.777344 30.222656 C 12.238344 22.683656 12.998047 15.999359 12.998047 15.443359 C 12.998047 14.640359 14.441859 11.879203 18.005859 12.033203 z" />
  </svg>
);
export const SnowflakeIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-16 h-16" fill="#29b5e8">
    <path d="M9.86 15.298l13.008 7.8a3.72 3.72 0 0 0 4.589-.601 4.01 4.01 0 0 0 1.227-2.908V3.956a3.81 3.81 0 0 0-1.861-3.42 3.81 3.81 0 0 0-3.893 0 3.81 3.81 0 0 0-1.861 3.42v8.896l-7.387-4.43a3.79 3.79 0 0 0-2.922-.4c-.986.265-1.818.94-2.3 1.844-1.057 1.9-.44 4.28 1.4 5.422m31.27 7.8l13.008-7.8c1.84-1.143 2.458-3.533 1.4-5.424a3.75 3.75 0 0 0-5.22-1.452l-7.3 4.37v-8.84a3.81 3.81 0 1 0-7.615 0v15.323a4.08 4.08 0 0 0 .494 2.367c.482.903 1.314 1.57 2.3 1.844a3.71 3.71 0 0 0 2.922-.4M29.552 31.97c.013-.25.108-.5.272-.68l1.52-1.58a1.06 1.06 0 0 1 .658-.282h.057a1.05 1.05 0 0 1 .656.282l1.52 1.58a1.12 1.12 0 0 1 .272.681v.06a1.13 1.13 0 0 1-.272.683l-1.52 1.58a1.04 1.04 0 0 1-.656.284h-.057c-.246-.014-.48-.115-.658-.284l-1.52-1.58a1.13 1.13 0 0 1-.272-.683zm-4.604-.65v1.364a1.54 1.54 0 0 0 .372.93l5.16 5.357a1.42 1.42 0 0 0 .895.386h1.312a1.42 1.42 0 0 0 .895-.386l5.16-5.357a1.54 1.54 0 0 0 .372-.93V31.32a1.54 1.54 0 0 0-.372-.93l-5.16-5.357a1.42 1.42 0 0 0-.895-.386h-1.312a1.42 1.42 0 0 0-.895.386L25.32 30.4a1.55 1.55 0 0 0-.372.93M3.13 27.62l7.365 4.417L3.13 36.45a4.06 4.06 0 0 0-1.399 5.424 3.75 3.75 0 0 0 2.3 1.844c.986.274 2.042.133 2.922-.392l13.008-7.8c1.2-.762 1.9-2.078 1.9-3.492a4.16 4.16 0 0 0-1.9-3.492l-13.008-7.8a3.79 3.79 0 0 0-2.922-.4c-.986.265-1.818.94-2.3 1.844-1.057 1.9-.44 4.278 1.4 5.422m38.995 4.442a4 4 0 0 0 1.91 3.477l13 7.8c.88.524 1.934.666 2.92.392s1.817-.94 2.3-1.843a4.05 4.05 0 0 0-1.4-5.424L53.5 32.038l7.365-4.417c1.84-1.143 2.457-3.53 1.4-5.422a3.74 3.74 0 0 0-2.3-1.844c-.987-.274-2.042-.134-2.92.4l-13 7.8a4 4 0 0 0-1.91 3.507M25.48 40.508a3.7 3.7 0 0 0-2.611.464l-13.008 7.8c-1.84 1.143-2.456 3.53-1.4 5.422.483.903 1.314 1.57 2.3 1.843a3.75 3.75 0 0 0 2.922-.392l7.387-4.43v8.83a3.81 3.81 0 1 0 7.614 0V44.4a3.91 3.91 0 0 0-3.205-3.903m28.66 8.276l-13.008-7.8a3.75 3.75 0 0 0-2.922-.392 3.74 3.74 0 0 0-2.3 1.843 4.09 4.09 0 0 0-.494 2.37v15.25a3.81 3.81 0 1 0 7.614 0V51.28l7.287 4.37a3.79 3.79 0 0 0 2.922.4c.986-.265 1.818-.94 2.3-1.844 1.057-1.9.44-4.28-1.4-5.422" />
  </svg>
);

export const DataBricksIcon = (
  <svg
    className="w-16 h-16"
    viewBox="0 0 395 428"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="db-nav-logo-stacked-white-desktop"
        fill="#FF3621"
        fillRule="nonzero"
      >
        <polygon
          id="Path"
          points="374.209708 176.201091 197.202491 276.206012 8.9097213 169.653015 0 174.414484 0 251.800317 197.202491 363.711726 374.209708 263.705397 374.209708 304.779048 197.202491 404.785376 8.9097213 298.230972 0 302.993849 0 316.089999 197.202491 428 395 316.089999 395 238.704166 386.090279 233.94129 197.202491 340.495694 20.7888786 240.489365 20.7888786 200.01125 197.202491 299.422043 395 187.510635 395 111.315873 384.901656 105.958446 197.202491 211.916329 30.2922044 117.268553 197.202491 23.2156091 335.006369 100.60102 347.480544 94.0529444 347.480544 84.5285992 197.202491 0 0 111.315873 0 123.221375 197.202491 235.132361 374.209708 135.126736"
        ></polygon>
      </g>
    </g>
  </svg>
);
